import Main from "./Pages/Main/Main";

function App() {
  return (
    <div>
      <Main />
    </div>
  );
}

export default App;
